module.exports = __webpack_public_path__ + "img/263.clean_garbage.869ab35f.svg";